import { useEffect } from "react";

const videos = [
  "/videos/project1.mp4",
  "/videos/project2.mp4",
  "/videos/project3.mp4",
  "/videos/project4.mp4",
  "/videos/project5.mp4",
];

export default function Reels() {

  useEffect(() => {
    const vids = document.querySelectorAll("video");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) video.play();
          else video.pause();
        });
      },
      { threshold: 0.7 }
    );

    vids.forEach(v => observer.observe(v));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="h-screen w-full bg-black overflow-y-scroll snap-y snap-mandatory">
      {videos.map((src, i) => (
        <div key={i} className="h-screen w-full snap-start relative">
          <video
            src={src}
            className="h-full w-full object-cover"
            muted
            loop
            playsInline
          />

          <div className="absolute bottom-10 left-6 text-white">
            <h2 className="text-xl font-semibold">Project {i + 1}</h2>
            <p className="text-sm opacity-80">Veda Creation & Group</p>
          </div>
        </div>
      ))}
    </div>
  );
}
